import { useCallback, useState } from 'react';

export default function useOpenController(initialState: boolean) {
    const [isOpen, setOpenState] = useState(initialState);

    const open = useCallback(() => {
        setOpenState(true);
    }, [setOpenState]);

    const close = useCallback(() => {
        setOpenState(false);
    }, [setOpenState]);

    const toggle = useCallback(() => {
        setOpenState((state) => !state);
    }, [setOpenState]);

    return { isOpen, open, close, toggle };
}
